import React from 'react';
import PropTypes from 'prop-types';
import { format, addDays } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { Card, CardContent, Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import GreenCheckIcon from '../../assets/icons/icon_green_check.svg';

const availableDateCardStyles = makeStyles({
  root: {
    backgroundColor: props => (props.selected ? '#0086FF' : '#F3F3F3'),
    color: props => (props.selected ? '#fff' : '#424242'),
    borderRadius: '6px',
    marginRight: props => (props.withCheck ? 0 : '16px'),
    marginBottom: props => (props.withCheck ? 0 : '16px'),
    textAlign: 'center',
    '& .MuiCardContent-root': {
      padding: '16px 24px',
    },
    '& span': {
      textTransform: 'capitalize',
    },
    '&:hover': {
      backgroundColor: props => (props.selected ? '#0086FF' : '#E5E5E5'),
      cursor: props => (props.onClick ? 'pointer' : 'normal'),
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.25)',
    },
  },
  boxCheckIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '-50px',
    marginRight: '-20px',
  },
});

export default function AvailableDateCard(props) {
  const { date, withCheck, onClick } = props;
  const classes = availableDateCardStyles(props);

  const formattedDate = addDays(new Date(date), 1);
  const dayOfWeek = format(formattedDate, 'EEEE', { locale: ptBR });
  const dayNumber = format(formattedDate, 'dd', { locale: ptBR });
  const month = format(formattedDate, 'MMMM', { locale: ptBR });

  return (
    <>
      {withCheck ? (
        <Box className={classes.boxCheckIcon}>
          <img src={GreenCheckIcon} alt="Ok" />
        </Box>
      ) : null}
      <Card className={classes.root} elevation={0} onClick={onClick}>
        <CardContent>
          <Box>
            <Typography component="div">
              <Box fontSize="16px">
                <span>{dayOfWeek}</span>
              </Box>
              <Box fontSize="46px" fontWeight="bold">
                {dayNumber}
              </Box>
              <Box fontSize="16px">
                de <span>{month}</span>
              </Box>
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </>
  );
}

AvailableDateCard.propTypes = {
  date: PropTypes.string.isRequired,
  withCheck: PropTypes.bool,
  onClick: PropTypes.func,
};

AvailableDateCard.defaultProps = {
  withCheck: false,
  onClick: null,
};
